module.exports = __webpack_public_path__ + "static/media/junk-is-no-good-baby.485ef6d6.txt";